var _title, _desc, _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEqualizer = function SvgEqualizer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Stockholm-icons / Media / Equalizer")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stockholm-icons-/-Media-/-Equalizer",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-62-Copy",
    fill: "#000000",
    opacity: 0.3,
    x: 13,
    y: 4,
    width: 3,
    height: 16,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-62-Copy-2",
    fill: "#000000",
    x: 8,
    y: 9,
    width: 3,
    height: 11,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-62-Copy-4",
    fill: "#000000",
    x: 18,
    y: 11,
    width: 3,
    height: 9,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-62-Copy-3",
    fill: "#000000",
    x: 3,
    y: 13,
    width: 3,
    height: 7,
    rx: 1.5
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEqualizer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Equalizer.8eae8061.svg";
export { ForwardRef as ReactComponent };